import { render, staticRenderFns } from "./CollectRentalPayment.vue?vue&type=template&id=5a894aca&"
import script from "./CollectRentalPayment.vue?vue&type=script&lang=js&"
export * from "./CollectRentalPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports